<template>
  <basicContainer>
    <div class="cplb">
      <avue-crud :data="data" :option="option" v-model="obj" :page="page" @search-change="searchChange"
        @size-change="sizeChange" @current-change="currentChange" :table-loading="loading" @row-save="rowSave"
        @row-update="rowUpdate" @row-del="rowDel">
      </avue-crud>
    </div>
  </basicContainer>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      page: {
        pageSize: 10,
        total: 0,
        currentPage: 1
      },
      searchkey: null,
      obj: {},
      data: [],
      option: {
        title: '参评类别列表',
        align: 'center',
        menuAlign: 'center',
        border: true,
        refreshBtn: false,
        columnBtn: false,
        viewBtn: true,
        labelWidth: 160,
        searchMenuSpan: 6,
        column: [
          {
            label: '参评大类',
            prop: 'cpdl_mc',
            type: 'select',
            search: true,
            editDisabled: true,
            rules: [{
              required: true,
              message: "请选择参评大类",
              trigger: "blur"
            }],
            dicData: []
          },
          {
            label: '参评类别代码',
            prop: 'id',
            editDisabled: true,
            addDisplay: false
          },
          {
            label: '参评类别名称',
            prop: 'lbmc',
            searchLabelWidth: 150,
            rules: [{
              required: true,
              message: "请输入参评类别名称",
              trigger: "blur"
            }]
          },
          {
            label: '是否启用资格限定器',
            prop: 'qyzgxdq',
            type: 'select',
            // rules: [{
            //     required: true,
            //     message: "选择是否启用资格限定器",
            //     trigger: "blur"
            // }]

          },
          {
            label: '参评班级',
            prop: 'cpbj',
            type: 'select',
            // rules: [{
            //     required: true,
            //     message: "请选择参评班级",
            //     trigger: "blur"
            // }]

          },
          {
            label: '状态',
            prop: 'zt',
            type: 'select',
            search: true,
            rules: [{
              required: true,
              message: "请选择状态",
              trigger: "blur"
            }],
            dicData: [
              {
                label: '启用',
                value: 1
              },
              {
                label: '禁用',
                value: 2
              }
            ]

          }
        ]
      }
    }
  },
  methods: {
    // 新增
    rowSave(row, done, loading) {
      // console.log(row);
      let newrow = {}
      Object.assign(newrow, { lbmc: row.lbmc, cpdl_id: row.cpdl_mc, zt: row.zt });
      // console.log(newrow)
      this.$http.post("/cplb/addOrUpdate", newrow).then(res => {
        // console.log(res);
        if (res.data === "参评类别名称重复") {
          this.$message.warning(res.data);
        }
        this.onLoad("", "", this.searchkey);
        done();
      }).catch(error => {
        this.$message.error(error.msg);
        // this.$Log.capsule('新增-失败', error, 'danger')
      })
    },
    // 编辑
    rowUpdate(row, index, done, loading) {
      // console.log(row);
      let newrow = {};
      if (row.zt === "启用") {
        row.zt = 1
      }
      if (row.zt === "禁用") {
        row.zt = 2
      }
      // console.log(newrow);
      Object.assign(newrow,
        {
          id: row.id,
          cpdl_id: row.cpdl_id,
          zt: row.zt,
          lbmc: row.lbmc
        });
      this.$http.post("/cplb/addOrUpdate", newrow).then(res => {
        if (res.data === "参评类别名称重复") {
          this.$message.warning(res.data);
        }
        this.onLoad("", "", this.searchkey);
        this.$message.success('修改成功');
        done();
      }).catch(error => {
        this.$message.error(error.msg);
        // this.$Log.capsule('修改-失败', error, 'danger')
      })
    },
    // 删除
    rowDel(row, index) {
      // console.log(row);
      this.$confirm('此操作将永久删除该数据, 是否继续?', '删除', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http.post("/cplb/delete", null, {
          params: {
            id: row.id
          }
        }).then(res => {
          // console.log(res);
          this.onLoad();
          this.$message({
            type: 'success',
            message: '删除成功!'
          });
        }).catch(error =>
          this.$message.error(error.msg)
          // this.$Log.capsule('参评类别 -删除失败', error.msg, 'danger')
        )
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },



    // 搜索查询
    searchChange(params, done) {
      this.searchkey = params;
      params.cpdl_id = params.cpdl_mc;
      delete params.cpdl_mc;
      typeof done === "function" && done();
      this.onLoad(1, "", params);
      console.log(params)
    },
    // 选择每页展示条数
    sizeChange(val) {
      this.onLoad("", val, this.searchkey);
    },
    // 翻页
    currentChange(val) {
      this.onLoad(val, "", this.searchkey);
    },
    // 分页查询
    onLoad(pageNum, pageSize, params) {
      if (pageNum) this.page.currentPage = pageNum;
      if (pageSize) this.page.pageSize = pageSize;
      params = params || null;
      let fenye = {
        pageNum: this.page.currentPage,
        pageSize: this.page.pageSize
      }
      this.loading = true;
      this.$http.get("/cplb/query", {
        params: Object.assign(fenye, params)
      }).then(res => {
        let dataArr = res.data.records.map(e => {
          if (e.zt === 1) {
            e.zt = "启用"
          } else {
            e.zt = "禁用"
          }
          return e
        })
        this.data = res.data.records;
        this.page.total = res.data.total || res.data.records.length;
        this.loading = false;
      })
    },
  },
  mounted() {
    this.onLoad();

    // 获取参评大类集合
    this.$http.get("/cpdl/list").then(res => {
      let arrDate = [];
      res.data.forEach(element => {
        arrDate.push({
          label: element.dlmc,
          value: element.id
        })
      });
      let column = this.option.column
      let index = this.findArray(column, "cpdl_mc", 'prop');
      column[index].dicData = arrDate;
    })
  },
}
</script>

<style lang="scss" scoped>
.cplb {
  padding: 20px 20px 100px;
  background-color: #fff;
}
</style>